$(document).ready(function () {

    const enabled = "nav--menu-item dropdown--trigger";
    const disabled = "disabled-menu-item";

    let host = window.location.origin;
    let currentUrl = window.location.href;

    currentUrl = currentUrl.replace(host, "");
    if(currentUrl == '/')
    {
      const navDom = $($("#main-nav").find('li a:contains("Homes")')[0].parentNode)[0];
      const screenWidth = window.screen.width;

      if(window.screen.width >= 1024){
        $("#homes").css("display","none");
        navDom.classList = "";
        navDom.classList.add(disabled);
      }
      else{
        $("#homes").css("display","unset")
      }
      //$("#homes").css("display","none");
    }
    else{
      $("#homes").css("display","unset")
    }
    


  });
  